import React from 'react'
import './logo.css';
import { Typography } from '@mui/material';

const Logo = () => {
    return (
        <div className='logo'>
            <Typography>Vistagram</Typography>
        </div>
    )
}

export default Logo